/**
 * YODEYMA_MARKET_TAX — mirrors theme bundle money helper (same separators & trailing zeros).
 * Removal: snippets/yodeyma-market-tax-cents.liquid (checklist); grep YODEYMA_MARKET_TAX.
 */
(function () {
  'use strict';

  function formatMoneyMinorUnits(cents, formatOverride) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var s =
      formatOverride ||
      (window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat);
    var n = window.themeVariables.settings.moneyWithoutTrailingZeros || false;

    function r(l, c) {
      return l == null || l !== l ? c : l;
    }

    function a(l, c, d, h) {
      if (((c = r(c, 2)), (d = r(d, ',')), (h = r(h, '.')), isNaN(l) || l == null)) return 0;
      if ((n && /00$/.test(l.toString())) || l === 0) c = 0;
      if (c === 0 && !/00$/.test(l.toString()) && l !== 0) c = 2;
      l = (l / 100).toFixed(c);
      var g = l.split('.'),
        b = g[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + d),
        p = g[1] ? h + g[1] : '';
      return b + p;
    }

    var o = '';
    switch (s.match(placeholder)[1]) {
      case 'amount':
        o = a(cents, 2);
        break;
      case 'amount_no_decimals':
        o = a(cents, 0);
        break;
      case 'amount_with_space_separator':
        o = a(cents, 2, ' ', '.');
        break;
      case 'amount_with_comma_separator':
        o = a(cents, 2, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        o = a(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        o = a(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        o = a(cents, 0, ' ');
        break;
      case 'amount_no_decimals_with_apostrophe_separator':
        o = a(cents, 0, "'");
        break;
      default:
        o = a(cents, 2);
    }
    return s
      .replace(placeholder, o)
      .replace(/\s+€/g, '€')
      .replace(/\s+EUR/gi, 'EUR');
  }

  window.yodeymaMarketTaxFormatMoney = formatMoneyMinorUnits;
})();
